<template>
    <div class="place-self-center">
        <h2 class="font-semibold text-xl text-white text-center mt-5">
            Confirmação de Dados para<br>Pagamento Pix
        </h2>
        <div class="mx-5 text-left">
                <span class="text-sm leading-none text-gray-400">
                    Por favor, verifique e confirme seus dados para prosseguir com a transação. Após a confirmação, você receberá o QR code para pagamento.
                </span>
        </div>
        <div class="border border-white bg-white rounded-xl p-3 mx-0 my-5 max-w-lg mb-16">
            <div class="m-5">
                <div class="ml-5">
                    <jet-label class="col-span-6" value="CPF"/>
                </div>
                <div class="grid grid-cols-6 col-span-6 relative">
                    <jet-masked-input
                        class="col-span-12 rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        :mask="['###.###.###-##']"
                        type="text"
                        placeholder="Digite seu CPF"
                        v-model="form.federal_document"/>
                    <div v-show="searchingFederalDocument" class="absolute right-3 top-2.5">
                        <div>
                            <i class="fas fa-spinner animate-spin text-2xl text-yellow-400"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-5">
                <div class="ml-5">
                    <jet-label class="col-span-6" value="E-mail"/>
                </div>
                <div class="grid grid-cols-6 col-span-6">
                    <jet-input
                        class="col-span-12 rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        type="email"
                        placeholder="Digite seu E-mail"
                        v-model="form.email"/>
                </div>
            </div>
            <div class="m-5">
                <div class="ml-5">
                    <jet-label class="col-span-6" value="Telefone"/>
                </div>
                <div class="grid grid-cols-6 col-span-6">
                    <jet-masked-input
                        class="col-span-12 rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        :mask="['(##) #####-####']"
                        type="text"
                        placeholder="Digite seu telefone de contato"
                        v-model="form.phone_number"/>
                </div>
            </div>
            <div class="m-5">
                <div class="ml-5">
                    <jet-label class="col-span-6" value="Profissão"/>
                </div>
                <div class="grid grid-cols-6 col-span-6">
                    <jet-input
                        class="col-span-12 rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        type="text"
                        placeholder="Ex: Engenheiro industrial"
                        v-model="form.occupation"/>
                </div>
            </div>
            <div class="m-5">
                <div class="ml-5">
                    <jet-label class="col-span-6" value="CEP"/>
                </div>
                <div class="grid grid-cols-6 col-span-6 relative">
                    <jet-masked-input
                        class="col-span-12 rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        :mask="['#####-###']"
                        type="text"
                        placeholder="Digite seu CEP"
                        v-model="form.address.zip_code"/>
                    <div v-show="fetchingZipCode" class="absolute right-3 top-2.5">
                        <div>
                            <i class="fas fa-spinner animate-spin text-2xl text-yellow-400"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-5">
                <div class="ml-5">
                    <jet-label class="col-span-6" value="Rua"/>
                </div>
                <div class="grid grid-cols-6 col-span-6">
                    <jet-input
                        class="col-span-12 rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        type="text"
                        placeholder="Ex: Avenida Paulista"
                        v-model="form.address.street"/>
                </div>
            </div>
            <div class="m-5">
                <div class="ml-5">
                    <jet-label class="col-span-6" value="Número"/>
                </div>
                <div class="grid grid-cols-6 col-span-6">
                    <jet-input
                        class="col-span-12 rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        type="text"
                        placeholder="Ex: Casa 10"
                        v-model="form.address.number"/>
                </div>
            </div>
            <div class="m-5">
                <div class="ml-5">
                    <jet-label class="col-span-6" value="Bairro"/>
                </div>
                <div class="grid grid-cols-6 col-span-6">
                    <jet-input
                        class="col-span-12 rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        type="text"
                        placeholder="Ex: Bairro central"
                        v-model="form.address.neighborhood"/>
                </div>
            </div>
            <div class="m-5">
                <div class="ml-5">
                    <jet-label class="col-span-6" value="Complemento"/>
                </div>
                <div class="grid grid-cols-6 col-span-6">
                    <jet-input
                        class="col-span-12 rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        type="text"
                        placeholder="Ex: Casa vermelha"
                        v-model="form.address.complement"/>
                </div>
            </div>
            <div class="m-5 grid grid-cols-12 gap-6">
                <div class="col-span-8">
                    <div class="ml-5">
                        <jet-label class="col-span-6" value="Cidade"/>
                    </div>
                    <jet-input
                        class="w-full rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        type="text"
                        placeholder="Ex: São Paulo"
                        v-model="form.address.city"/>
                </div>
                <div class="col-span-4">
                    <div class="ml-5">
                        <jet-label class="col-span-6" value="UF"/>
                    </div>
                    <jet-input
                        class="w-full rounded-3xl border border-solid border-black text-gray-700 py-2 px-5"
                        type="text"
                        placeholder="Ex: SP"
                        v-model="form.address.state"/>
                </div>
            </div>
            <div class="m-5">
                <input
                    class="appearance-none text-center text-gray-300 h-5 w-5 border-2 border-gray-600 rounded checked:bg-green-600 checked:border-transparent fas fa-check"
                    type="checkbox" name="" id="check_terms" v-model="form.confirm_terms"
                />
                <label for="check_terms">Eu li e concordo com os termos apresentados: </label>
                <span @click="showTerms" class="text-yellow-600 cursor-pointer">Termos de transação cambial</span>
            </div>
        </div>
    </div>
</template>
<script>

import JetLabel from "../../Jetstream/Label.vue";
import JetMaskedInput from "../../Jetstream/MaskedInput.vue";
import JetInput from "../../Jetstream/Input.vue";

export default {
    components: {JetInput, JetMaskedInput, JetLabel},
    props: ['form','fetchingZipCode','searchingFederalDocument'],
    methods:{

        showTerms() {
            console.log("terms")
        }
    }
}


</script>
